class ToggleComponent extends HTMLElement {
  connectedCallback() {
    // Listen for the checkbox input change within the component
    const checkInput = this.querySelector(".toggle__input--hidden");
    const toggleInput = this.querySelector(".toggle__input");
    if (checkInput) {
      checkInput.addEventListener("change", () => {
        // Toggle the active class based on the checkbox's checked state
        toggleInput.classList.toggle("toggle__input--active", checkInput.checked);
      });
    }
  }

  disconnectedCallback() {
    // Optionally, remove event listeners if needed for cleanup
    const checkInput = this.querySelector(".toggle__input--hidden");
    if (checkInput) {
      checkInput.removeEventListener("change", this.handleToggle);
    }
  }
}

// Register the custom element
customElements.define("toggle-component", ToggleComponent);
